import {AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild, ViewEncapsulation} from '@angular/core';
import {UserService} from "../../services/user.service";
import {Router} from "@angular/router";


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class HeaderComponent implements OnInit, AfterViewInit {
  utente = "";
  gruppo = "";
  toggle = 0;
  @ViewChild('navbarUser', {static: false})
  navbarUser!: ElementRef;

  constructor(private userService: UserService, private router: Router, private renderer: Renderer2) {
  }


  ngAfterViewInit(): void {
    this.setMenuDimensions();
    window.addEventListener('resize', this.setMenuDimensions.bind(this));
  }

  public clickToggle() {
    this.toggle++;
    const navbarUserElement = this.navbarUser.nativeElement;
    const dropdownMenu = navbarUserElement.querySelector('.dropdown-menu');
    if (this.toggle % 2 == 0) {
      this.renderer.setStyle(dropdownMenu, 'display', 'none');
    } else {
      this.renderer.setStyle(dropdownMenu, 'display', 'block');
    }
  }

  setMenuDimensions() {
    if (this.navbarUser) {
      const navbarUserElement = this.navbarUser.nativeElement;
      const parentElement = navbarUserElement.parentElement;

      const parentRect = parentElement.getBoundingClientRect();
      const navbarUserRect = navbarUserElement.getBoundingClientRect();

      // Imposta la larghezza del dropdown-menu per essere uguale a quella del parent
      const dropdownMenu = navbarUserElement.querySelector('.dropdown-menu');
      this.renderer.setStyle(dropdownMenu, 'top', `${navbarUserRect.bottom + 10}px`);
      this.renderer.setStyle(dropdownMenu, 'left', `${navbarUserRect.left}px`);
      this.renderer.setStyle(dropdownMenu, 'padding', `10px`);
      this.renderer.setStyle(dropdownMenu, 'position', 'absolute');
    }
  }

  async ngOnInit() {
    const user = await this.userService.getUser();
    if (user) {
      this.utente = user.nome + " " + user.cognome
      this.gruppo = user.businessUnit
    }


  }

  logout() {
    this.router.navigate(['end-session']);
  }


  // Function to set menu dimensions


  // Set initial dimensions

}
